<template>
  <div class="day">
    <span class="letter">{{ label }}</span>
    <span class="number" 
      :class="{
         'active': active,
         'disabled': disabled
      }">
          {{ number }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'dayWeek',
  props:["number","label","active","disabled"],
}
</script>

<style scoped>
.day {
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  flex-grow: 1;
  /* each day will take up an equal amount of space */
  padding-right: 10px;
  padding-left: 10px;
}

.day:first-of-type{
  padding-left: 0;
}

.day:last-of-type{
  padding-right: 0;
}

.day .letter {
  font-size: 10px;
  color: #a8aaab;
}

.day .number {
  font-size: 14px;
  font-family: "Montserrat SemiBold";
  padding-left: 5px;
  padding-right: 5px;
}

.day .number.disabled{
  color: #a8aaab;
}

.day .number.active {
  background: #2e59e4;
  color: white;
  border-radius: 50%;
}

.letter {
  font-family: "Montserrat Light";
}


</style>